import { useGetConvertRecentQuery } from "@/store/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

/**
 * ConvertHistoryCard — recent Binance Convert attempts. Secondary path
 * only; STF-blocked exits go through Binance Web3 Wallet (the operator
 * imports the bot's BSC wallet there). Convert is useful for dust /
 * graduated tokens already sitting on Binance Spot.
 */
export function ConvertHistoryCard() {
  const data = useGetConvertRecentQuery({ limit: 30 }, { pollingInterval: 60000 });
  const rows: any[] = data.data?.attempts || [];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base flex items-center justify-between flex-wrap gap-2">
          <span>Binance Convert — recent</span>
          <span className="text-xs font-normal text-muted">
            secondary path · stuck STF exits use Web3 Wallet
          </span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        {rows.length === 0 ? (
          <div className="text-sm text-muted">
            No convert attempts yet. Used only for dust sweeps and
            graduated-token exits already on Spot.
          </div>
        ) : (
          <div className="border border-border rounded overflow-hidden max-h-72 overflow-y-auto">
            <table className="w-full text-xs">
              <thead className="bg-bg2 text-left text-muted sticky top-0">
                <tr>
                  <th className="py-1 px-2">Time</th>
                  <th className="py-1 px-2">From → To</th>
                  <th className="py-1 px-2 text-right">From qty</th>
                  <th className="py-1 px-2 text-right">To qty</th>
                  <th className="py-1 px-2">Source</th>
                  <th className="py-1 px-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((r: any) => {
                  const ok = (r.status || "").includes("ok") || r.status === "SUCCESS";
                  return (
                    <tr key={r.id} className="border-t border-border/40">
                      <td className="py-1 px-2 text-muted">{(r.ts || "").slice(5, 19).replace("T", " ")}</td>
                      <td className="py-1 px-2 font-mono">{r.from_asset} → {r.to_asset}</td>
                      <td className="py-1 px-2 text-right font-mono">{Number(r.from_amount || 0).toFixed(6)}</td>
                      <td className="py-1 px-2 text-right font-mono">{Number(r.to_amount || 0).toFixed(4)}</td>
                      <td className="py-1 px-2 text-xs">{r.source}</td>
                      <td className="py-1 px-2">
                        <Badge tone={ok ? "good" : "bad"}>{r.status || r.reason || "?"}</Badge>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
